<template>
  <div
    class="fear-overtime-alert-tooltip-text z-10 aisea-text-14-400-white pl-1"
  >
    <div class="alert-title">過去48時間以内に以下のアラートが発生している人数を表示しています。</div>
    <div class="alert-item">・過去24時間の労働時間が10時間以上〜14時間以内</div>
    <div class="alert-item">・過去7日間の労働時間が68時間以上〜72時間以内</div>
  </div>
</template>
<script>
export default {
  name: "TooltipTextFearOvertime",
  components: {},
};
</script>
<style lang="scss">
.fear-overtime-alert-tooltip-text {
  .alert-title {
    margin-bottom: 10px;
  }
  .alert-item {
    font-weight: 600;
  }
}
</style>
